import moment from 'moment';

import * as graphql from 'generated/graphql';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';

import LineMetric from '../LineMetric';

export default function SessionsOverTimeMetric({
	loading,
	bucketSize,
	data,
}: {
	loading: boolean;
	bucketSize: graphql.AnalyticsBucketSize;
	data?: graphql.AnalyticsSessionsBucket[];
}) {
	let labels: string[];

	if (loading || !data) {
		return <Spinner isLoading size="18px" />;
	}

	switch (bucketSize) {
		case graphql.AnalyticsBucketSize.Day:
			labels = data.map((bucket) => {
				return moment.utc(bucket.bucketStart).format('YYYY-MM-DD');
			});
			break;
		case graphql.AnalyticsBucketSize.Week:
			labels = data.map((bucket) => {
				const date = moment.utc(bucket.bucketStart);

				if (moment.utc().startOf('year').isAfter(date)) {
					return date.format("[Week] WW [']YY");
				}

				return date.format('[Week] WW');
			});
			break;
		default:
			labels = data.map((bucket) => {
				return moment.utc(bucket.bucketStart).format("MMM [']YY");
			});
	}

	const values = data.map(({ sessions }) => sessions);

	return <LineMetric labels={labels} values={values} />;
}
